import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Table from "src/componets/Table";
import Pagination from "src/componets/Pagination";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { PhoneNumberPriceHistoryInterface } from "src/store/callrecorder/phoneNumberPriceHistoriesSlice";
import { fetchPhoneNumberPriceHistories } from "src/actions/callrecorder/phoneNumberPriceHistoriesActions";
import { formattedDate } from "src/helpers/DateHelpers";
import { getCurrencySymbol } from "src/helpers/CurrencyHelper";
import { queryParams } from "src/helpers/UrlHelpers";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Tag } from "antd";

const LIMIT = 42;

const _ListTable = ({ filterParams }: { filterParams: object }) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams, 'page') || 1;

  const ids = useAppSelector(state => state.callrecorder.phoneNumberPriceHistories.ids);
  const entities = useAppSelector(state => state.callrecorder.phoneNumberPriceHistories.entities);
  const count = useAppSelector(state => state.callrecorder.phoneNumberPriceHistories.count);
  const data = ids ? ids.map(id => entities[id]) : [];

  useEffect(() => {
    dispatch(fetchPhoneNumberPriceHistories({
      ...filterParams,
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    }));
  }, [filterParams, currentPage, dispatch]);

  const priceChange = (prev: string | null, next: string | null, currency: string) => {
    if (!prev && !next) return '—';
    const symbol = getCurrencySymbol(currency);
    const changed = prev !== next;
    return (
      <span>
        <small style={changed ? { background: '#fff1f0', padding: '1px 4px', borderRadius: 3 } : {}}>{prev ? `${prev}${symbol}` : '—'}</small>
        {' '}<ArrowRightOutlined style={{ fontSize: 10, color: '#999' }} />{' '}
        <small style={changed ? { background: '#f6ffed', padding: '1px 4px', borderRadius: 3 } : {}}><strong>{next ? `${next}${symbol}` : '—'}</strong></small>
      </span>
    );
  };

  const columns: ColumnsType<PhoneNumberPriceHistoryInterface> = [
    {
      key: 'phone_number_price_id',
      title: 'Price ID',
      render: (_, { phone_number_price_id }) => `#${phone_number_price_id}`,
      width: 80
    },

    {
      key: 'monthly_fee',
      title: 'Monthly Fee',
      render: (_, record) => priceChange(record.previous_monthly_fee, record.new_monthly_fee, record.new_currency),
      width: 160
    },

    {
      key: 'raw_monthly_fee',
      title: 'Raw Monthly',
      render: (_, record) => priceChange(record.previous_raw_monthly_fee, record.new_raw_monthly_fee, record.new_currency),
      width: 150
    },

    {
      key: 'inbound_cost_per_min',
      title: 'Inbound Call',
      render: (_, record) => priceChange(record.previous_inbound_cost_per_min, record.new_inbound_cost_per_min, record.new_currency),
      width: 160
    },

    {
      key: 'raw_inbound_trunking_price',
      title: 'Raw In Call',
      render: (_, record) => priceChange(record.previous_raw_inbound_trunking_price, record.new_raw_inbound_trunking_price, record.new_currency),
      width: 160
    },

    {
      key: 'inbound_sms_price',
      title: 'Inbound SMS',
      render: (_, record) => priceChange(record.previous_inbound_sms_price, record.new_inbound_sms_price, record.new_currency),
      width: 160
    },

    {
      key: 'raw_inbound_sms_price',
      title: 'Raw In SMS',
      render: (_, record) => priceChange(record.previous_raw_inbound_sms_price, record.new_raw_inbound_sms_price, record.new_currency),
      width: 160
    },

    {
      key: 'source',
      title: 'Source',
      render: (_, { source }) => <Tag>{source}</Tag>,
      width: 100
    },

    {
      key: 'changed_at',
      title: 'Changed',
      render: (_, { changed_at }) => <small>{formattedDate(changed_at).dateTime}</small>,
      width: 125
    },
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={LIMIT} />
    </div>
  )
}

export default _ListTable;
